module.exports = __webpack_public_path__ + "img/Toilet Icon - white.d3fae716.svg";